import { render, staticRenderFns } from "./tabs-quarternary.vue?vue&type=template&id=987f7096&scoped=true&"
import script from "./tabs-quarternary.vue?vue&type=script&lang=js&"
export * from "./tabs-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987f7096",
  null
  
)

export default component.exports